<template>
  <div class="header-bg">
    <el-row>
      <el-col :span="6">
        <div class="header-tab">
          <div
            @click="tabChange(0)"
            class="header-tab-item"
            v-if="powerInfo.powerWarmState=='0'"
            :class="
              current == 0 ? 'header-tab-item-bg-sel' : 'header-tab-item-bg'
            "
          >
            智能温室
          </div>
          <div
            @click="tabChange(1)"
            class="header-tab-item"
            v-if="powerInfo.powerWaterState=='0'"
            :class="
              current == 1 ? 'header-tab-item-bg-sel' : 'header-tab-item-bg'
            "
          >
            智慧灌溉
          </div>
        </div>
      </el-col>
      <el-col :span="12" style="">
        <div
          class=""
          style="
            font-size: 2.5rem;
            font-family: YouSheBiaoTiHei;
            text-shadow: 0px 0px 10px #105ed9;
            margin-top: 0.75rem;
            font-weight: bold;
            color: #b1cffc;
            font-style: italic;
            letter-spacing: 2px;
          "
        >
          {{ title }}
        </div>
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-right: 5.9375rem;
            color: #00ccff;
            position: relative;
            top: -0.5rem;
            font-weight: bold;
          "
        ></div>
      </el-col>
      <el-col :span="6">
        <div class="header-tab">
          <div
            @click="tabChange(2)"
            class="header-tab-item"
            :class="
              current == 2 ? 'header-tab-item-bg-sel' : 'header-tab-item-bg'
            "
          >
            五情监测
          </div>
          <div
            @click="tabChange(3)"
            class="header-tab-item"
            :class="
              current == 3 ? 'header-tab-item-bg-sel' : 'header-tab-item-bg'
            "
          >
            农业溯源
          </div>
        </div>
        <div
          class=""
          style="
            display: inline-block;
            float: right;
            margin-right: 65px;
            margin-top: 5px;
          "
        >
          <img
            src="https://baigebackupdata.oss-cn-beijing.aliyuncs.com/zhihuinongye/1704247580455.png"
            @click="layoutOncick()"
            style="width: 32px; height: 32px; margin-right: 10px"
            alt=""
          />
          <img
            src="https://baigebackupdata.oss-cn-beijing.aliyuncs.com/zhihuinongye/1704248841047.png"
            @click="exitOncick()"
            style="width: 32px; height: 32px"
            alt=""
          />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "app",
  props: {
    // 当前活动tab的索引
    current: {
      type: [Number, String],
      default: 0,
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      userInfo: {},
      powerInfo: {
        powerWarmRegion1:"0006",
        powerWarmRegion2:"0004",
        powerWarmRegion3:"0004",
        powerWarmState:"0",
        powerWaterRegion1:"0010",
        powerWaterRegion2:"0010",
        powerWaterRegion3:"0010",
        powerWaterRegion4:"0010",
        powerWaterState:"0",
      }
    };
  },
  mounted() {
    // 从本地缓存中获取数据
    let userInfo = localStorage.getItem("user_info");
    // 将获取到的JSON字符串转换回对象
    this.userInfo = JSON.parse(userInfo);

    let powerInfo = localStorage.getItem("power_info");
    this.powerInfo = JSON.parse(powerInfo); 
  },
  methods: {
    exitOncick() {
      this.$confirm("退出系统, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "再想想",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post("/user/logout", {
              userId: this.userInfo.userId,
            })
            .then((res) => {
              console.log("退出登录-res===", res);
              localStorage.setItem("user_info", null);
              localStorage.setItem("power_info", null);
              this.$router.replace("/loginPage");
            })
            .catch((error) => {
              console.log("登录-error===", error);
            });
        })
        .catch(() => {});
    },
    layoutOncick() {
      this.$router.push("/index");
    },
    tabChange(index) {
      this.$emit("change", index);
    },
  },
};
</script>

<style>
.el-header {
  padding: 0rem;
}

.header-bg {
  height: 195px;
  background-color: #010c2a;
  background-image: url("https://baigebackupdata.oss-cn-beijing.aliyuncs.com/zhihuinongye/1704247871311.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #fff;
  text-align: center;
}

.header-tab {
  height: 3.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.header-tab-item-bg {
  background-image: url("https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1700796923942.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.header-tab-item-bg-sel {
  background-image: url("https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1700797305696.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.header-tab-item {
  cursor: pointer;
  text-align: center;
  color: #fff;
  font-weight: bold;
  width: 13.75rem;
  height: 3.125rem;
  margin-right: 1.875rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
